import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import AddRemainderModal from "../../components/asset-list/add-remainder-modal";

//PNG
import Logo from "../../assets/png/logo.png";
import Profile from "../../assets/png/profileview.png";
import Excel from "../../assets/png/excel.png";
import QrPng from "../../assets/png/qrpng.png";
import NoAsset from "../../assets/png/noasset.png";

//SVG
import Back from "../../assets/svg/backarrow.svg";
import Settings from "../../assets/svg/roundsettings.svg";
import Cost from "../../assets/svg/cost.svg";
import Allocated from "../../assets/svg/allocated.svg";
import Qr from "../../assets/svg/qr.svg";
import Dropdown from "../../assets/svg/droparrow.svg";
import Down from "../../assets/svg/downarrow.svg";
import Location from "../../assets/svg/location.svg";
import IT from "../../assets/svg/it.svg";
import Used from "../../assets/svg/usedby.svg";
import Managed from "../../assets/svg/managedby.svg";
import LastReading from "../../assets/svg/lastreading.svg";
import Search from "../../assets/svg/searchicon.svg";
import Drag from "../../assets/svg/dots.svg";
import Plus from "../../assets/svg/plus.svg";
import PageLeft from "../../assets/svg/pageleft.svg";
import PageRight from "../../assets/svg/pageright.svg";
import Download from "../../assets/svg/download 4.01.37 PM.svg";
import Reminder from "../../assets/svg/reminder.svg";
import Edit from "../../assets/svg/edit.svg";
import Delete from "../../assets/svg/delete.svg";
import Notification from "../../assets/svg/notification.svg";
import Warranty from "../../assets/svg/warranty.svg";
import Email from "../../assets/svg/email.svg";
import User from "../../assets/svg/users.svg";
import Mobile from "../../assets/svg/mobile.svg";
import Print from "../../assets/svg/print.svg";
import Downloadqr from "../../assets/svg/downloadqr 11.01.26 AM.svg";
import NoData from "../../assets/svg/nodata.svg";
import NoQr from "../../assets/svg/noqr.svg";
import NoProfile from "../../assets/svg/noprofile.svg";

//API
import { getAssetViewApi, getDataApi, getEditedHistoryApi, getFileApi, getGateApi, getHistoryApi, getProfileViewApi, getReminderViewApi, getValidationsApi, saveFileApi } from "./asset-api";
import { createReminderApi, getDeleteApi, updateReminderApi } from "../asset-list/asset-api";
import ReferenceViewModal from "./reference-view";
import DeleteModal from "../common/delete-modal";

//Utils
import { downloadQRCode, printQRCode } from "../common/utils";

const AssetView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  //SnackBar
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [showReminder, setShowReminder] = useState(false);

  //Action menu & Delete
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const actionMenuRef = useRef(null);

  const onSuccessDelete = (response) => {
    setIsOpenDelete(false);
    navigate("/asset", { state: { toastMessage: response?.message || "Asset deleted successfully", toastStatus: response?.success !== false } });
  };

  useEffect(() => {
    const sessionMsg = sessionStorage.getItem("toastMessage");
    const sessionStatus = sessionStorage.getItem("toastStatus");
    if (sessionMsg) {
      setSnackbarMessage(sessionMsg);
      setSnackbarStatus(sessionStatus !== "false");
      handleSnackbarShow();
      sessionStorage.removeItem("toastMessage");
      sessionStorage.removeItem("toastStatus");
    } else if (location.state?.toastMessage) {
      setSnackbarMessage(location.state.toastMessage);
      setSnackbarStatus(location.state.toastStatus !== false);
      handleSnackbarShow();
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setShowActionMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //Print & Download QR
  const qrRef = useRef(null);

  //Tabs
  const options = ["Gate Logs", "Assigned History", "Data Entries", "Validation", "Edited History", "Reminders", "File"];
  const [selectedTab, setSelectedTab] = useState("Gate Logs");

  //Toggle
  const [showAssetDetails, setShowAssetDetails] = useState(false);
  const [showMaintenanceDetails, setShowMaintenanceDetails] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [showQrDetails, setShowQrDetails] = useState(false);

  const handleAssetToggle = () => {
    setShowAssetDetails((prev) => !prev);
  };

  const handleMaintenanceToggle = () => {
    setShowMaintenanceDetails((prev) => !prev);
  };

  const handleInvoiceToggle = () => {
    setShowInvoiceDetails((prev) => !prev);
  };

  const handleQrToggle = () => {
    setShowQrDetails((prev) => !prev);
  };

  //Profile

  const [profileView, setProfileView] = useState("");
  useEffect(() => {
    getProfileView();
  }, []);

  const getProfileView = async () => {
    try {
      const response = await getProfileViewApi(id);
      if (response.data.success === true) {
        setProfileView(response.data.profile);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  //View Page

  const [assetView, setAssetView] = useState([]);
  useEffect(() => {
    getAssetView();
  }, []);

  const getAssetView = async () => {
    try {
      const response = await getAssetViewApi(id);
      if (response.data.success === true) {
        setAssetView(response.data.asset);
        console.log(response);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  //Gate Logs List

  const [gateList, setGateList] = useState([]);
  const [gateCount, setGateCount] = useState("");
  const [gatePageCount, setGatePageCount] = useState("");
  const [gateSearch, setGateSearch] = useState("");
  const [itemOffSetGate, setItemOffSetGate] = useState("");
  const [itemsPerGatePage, setItemsPerGatePage] = useState(10);

  const handleGatePageClick = useCallback(
    (event) => {
      setItemOffSetGate(event.selected);
    },
    [itemsPerGatePage, gateList.length]
  );

  const getGateList = async () => {
    try {
      const response = await getGateApi(id, {
        search: gateSearch,
        limit: itemsPerGatePage,
        skip: itemOffSetGate * itemsPerGatePage,
      });

      if (response.data.success === true) {
        setGateList(response.data.transactions);
        setGateCount(response.data.total_rec);
        setGatePageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching gate list:", err);
    }
  };

  useEffect(() => {
    if (selectedTab === "Gate Logs") {
      getGateList();
    }
  }, [selectedTab, gateSearch, itemOffSetGate, itemsPerGatePage]);

  //Assigned History List

  const [historyList, setHistoryList] = useState([]);
  const [historyCount, setHistoryCount] = useState("");
  const [historyPageCount, setHistoryPageCount] = useState("");
  const [historySearch, setHistorySearch] = useState("");
  const [itemOffsetHistory, setItemOffsetHistory] = useState("");
  const [itemsPerHistoryPage, setItemsPerHistoryPage] = useState(10);

  const handleHistoryPageClick = useCallback(
    (event) => {
      setItemOffsetHistory(event.selected);
    },
    [itemsPerHistoryPage, historyList.length]
  );

  const getHistoryList = async () => {
    try {
      const response = await getHistoryApi(id, {
        search: historySearch,
        limit: itemsPerHistoryPage,
        skip: itemOffsetHistory * itemsPerHistoryPage,
      });

      if (response?.data?.success === true) {
        setHistoryList(response.data.history);
      setHistoryCount(response.data.total_rec);
        setHistoryPageCount(response.data.total_pgs);
      }
    } catch (err) {
      console.error("Error fetching history:", err);
    }
  };

  useEffect(() => {
    if (selectedTab === "Assigned History") {
      getHistoryList();
    }
  }, [selectedTab, historySearch, itemOffsetHistory, itemsPerHistoryPage]);

  //Data Entries

  const [dataList, setDataList] = useState([]);
  const [dataCount, setDataCount] = useState("");
  const [dataPageCount, setDataPageCount] = useState("");
  const [dataSearch, setDataSearch] = useState("");
  const [itemOffsetData, setItemOffsetData] = useState("");
  const [itemsPerDataPage, setItemsPerDataPage] = useState(10);

  const handleDataPageClick = useCallback(
    (event) => {
      setItemOffsetData(event.selected);
    },
    [itemsPerDataPage, dataList.length]
  );

  const getDataList = async () => {
    try {
      const response = await getDataApi(id, {
        search: dataSearch,
        limit: itemsPerDataPage,
        skip: itemOffsetData * itemsPerDataPage,
      });

      if (response.data.success === true) {
        setDataList(response.data.history);
        setDataCount(response.data.total_rec);
        setDataPageCount(response.data.total_pgs);
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching data list:", err);
    }
  };

  useEffect(() => {
    if (selectedTab === "Data Entries") {
      getDataList();
    }
  }, [selectedTab, dataSearch, itemOffsetData, itemsPerDataPage]);

  //Validations Listing Page
  const [referenceId, setReferenceId] = useState("");
  const [showReferenceViewModal, setShowReferenceViewModal] = useState(false);

  const [validationsList, setValidationsList] = useState([]);
  const [validationsCount, setValidationsCount] = useState("");
  const [validationsPageCount, setValidationsPageCount] = useState("");
  const [validationsSearch, setValidationsSearch] = useState("");
  const [itemOffsetValidations, setItemOffsetValidations] = useState("");
  const [itemsPerValidationsPage, setItemsPerValidationsPage] = useState(10);

  const handleValidationsPageClick = useCallback(
    (event) => {
      setItemOffsetValidations(event.selected);
    },
    [itemsPerValidationsPage, validationsList.length]
  );

  const getValidationsList = async () => {
    try {
      const response = await getValidationsApi(id, {
        search: validationsSearch,
        limit: itemsPerValidationsPage,
        skip: itemOffsetValidations * itemsPerValidationsPage,
      });

      if (response.data.success === true) {
        setValidationsList(response.data.validations);
        setValidationsCount(response.data.total_rec);
        setValidationsPageCount(response.data.total_pgs);
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching validations:", err);
    }
  };

  useEffect(() => {
    if (selectedTab === "Validation") {
      getValidationsList();
    }
  }, [selectedTab, validationsSearch, itemOffsetValidations, itemsPerValidationsPage]);

  useEffect(() => {
    if (referenceId !== "") {
      setShowReferenceViewModal(true);
    }
  }, [referenceId]);

  //Edited History List

  // State
  const [editedHistoryList, setEditedHistoryList] = useState([]);
  const [editedHistoryCount, setEditedHistoryCount] = useState("");
  const [editedHistoryPageCount, setEditedHistoryPageCount] = useState("");
  const [editedHistorySearch, setEditedHistorySearch] = useState("");
  const [itemOffsetEditedHistory, setItemOffsetEditedHistory] = useState(0);
  const [itemsPerEditedHistoryPage, setItemsPerEditedHistoryPage] = useState(10);

  // Pagination Click Handler
  const handleEditedHistoryPageClick = useCallback(
    (event) => {
      setItemOffsetEditedHistory(event.selected);
    },
    [itemsPerEditedHistoryPage, editedHistoryList.length]
  );

  const getEditedHistoryList = async () => {
    try {
      const response = await getEditedHistoryApi(id, {
        search: editedHistorySearch,
        limit: itemsPerEditedHistoryPage,
        skip: itemOffsetEditedHistory * itemsPerEditedHistoryPage,
      });

      if (response.data.success === true) {
        setEditedHistoryList(response.data.activities);
        setEditedHistoryCount(response.data.total_rec);
        setEditedHistoryPageCount(response.data.total_pgs);
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching edited history:", err);
    }
  };

  useEffect(() => {
    if (selectedTab === "Edited History") {
      getEditedHistoryList();
    }
  }, [selectedTab, editedHistorySearch, itemOffsetEditedHistory, itemsPerEditedHistoryPage]);

  // Reminders View
  const [editReminder, setEditReminder] = useState(null);
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    if (selectedTab === "Reminders") {
      getReminderView();
    }
  }, [selectedTab]);

  const getReminderView = async () => {
    try {
      const response = await getReminderViewApi(id);
      if (response.data.success === true) {
        setReminders(response.data.reminders);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const [fileView, setFileView] = useState([]);
  useEffect(() => {
    if (selectedTab === "File") {
      getFileView();
    }
  }, [selectedTab]);

  const getFileView = async () => {
    try {
      const response = await getFileApi(id);
      if (response.data.success === true) {
        setFileView(response.data.attachments);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  //Files Save
  const handleFileUpload = async (event) => {
    const selectedFiles = [...event.target.files];
    const maxFileSize = 5 * 1024 * 1024; // 5MB

    // Filter valid files (<= 5MB)
    const underSizeFiles = selectedFiles.filter((file) => file.size <= maxFileSize);

    // If no valid files, skip upload entirely
    if (underSizeFiles.length === 0) return;

    try {
      const base64Files = await Promise.all(underSizeFiles.map(toBase64));
      const payload = { attachments: base64Files };

      const response = await saveFileApi(id, payload);

      if (response?.data?.message) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        setShowSnackbar(true);

        if (response.data.success) {
          getFileView(); // Refresh file list
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      setSnackbarMessage("An unexpected error occurred.");
      setSnackbarStatus(false);
      setShowSnackbar(true);
    }
  };

  // Utility: Convert file to base64
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(new Error(error));
    });

  const onSuccessReminder = async (result) => {
    result["asset_id"] = assetView.id;
    if (editReminder === null) {
      const response = await createReminderApi(result);
      if (response.status === 200) {
        if (response.data.success === true) {
          setShowReminder(false);
          setEditReminder(null);
          getReminderView();
        }
      }
    } else {
      const response = await updateReminderApi(id, result);
      if (response.status === 200) {
        if (response.data.success === true) {
          setShowReminder(false);
          setEditReminder(null);
          getReminderView();
        }
      }
    }
  };

  useEffect(() => {
    if (editReminder !== null) {
      setShowReminder(true);
    }
  }, [editReminder]);

  const deleteReminderApi = async (id) => {
    try {
      const response = await getDeleteApi(`reminder/${id}`);
      if (response?.status === 200 || response?.status === 500) {
        getReminderView();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  if (!assetView || Array.isArray(assetView)) {
    return (
      <div style={{ fontFamily: "Lexend Deca", width: "100%", minHeight: "100%", backgroundColor: "#F0F4F9", padding: "16px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "Lexend Deca", width: "100%", minHeight: "100%", backgroundColor: "#F0F4F9", padding: "16px", textAlign: "left" }}>
      {showReminder === true && (
        <AddRemainderModal
          editReminder={editReminder}
          invoiceDate={assetView.invoice_date != null && assetView.invoice_date !== "" ? assetView.invoice_date : ""}
          warrantyUnit={assetView.warranty_unit != null && assetView.warranty_unit !== "" ? assetView.warranty_unit : "Year"}
          warrantyPeriod={assetView.warranty_value != null && assetView.warranty_value !== "" ? assetView.warranty_value : ""}
          onSuccess={onSuccessReminder}
          onCancel={() => {
            setShowReminder(false);
            setEditReminder(null);
          }}
        />
      )}
      {showReferenceViewModal === true && (
        <ReferenceViewModal
          referenceId={referenceId}
          onCancel={() => {
            setShowReferenceViewModal(false);
            setReferenceId("");
          }}
        />
      )}
      {isOpenDelete && (
        <DeleteModal
          deleteUrl={`asset/delete/${id}`}
          ids={null}
          onSuccess={onSuccessDelete}
          onCancel={() => setIsOpenDelete(false)}
        />
      )}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body className="text-white">{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <Row>
        <Col xs={12} sm={12} md={12} lg={6} xl={4} className="mb-0 mb-md-3">
          <div style={{ width: "100%", borderRadius: "24px", padding: "24px", backgroundColor: "#ffffff" }}>
            <Row style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
              <Col sm={6}>
                <button
                  onClick={() => navigate(-1)}
                  style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                  aria-label="Back"
                >
                  <img alt="Back" src={Back} style={{ height: "40px" }} />
                </button>
              </Col>

              <Col sm={6}>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" }}>
                  <button onClick={() => navigate(`/asset/edit/${id}`, { state: { id } })} style={{ height: "40px", borderRadius: "100px", padding: "10px 28px", backgroundColor: "#1967d2", fontWeight: "600", fontSize: "15px", color: "#ffffff", cursor: "pointer", lineHeight: "none", border: "none" }}>
                    Edit
                  </button>

                  <div style={{ position: "relative" }} ref={actionMenuRef}>
                    <img
                      src={Settings}
                      alt="Actions"
                      style={{ height: "40px", cursor: "pointer" }}
                      onClick={() => setShowActionMenu((prev) => !prev)}
                      title="More actions"
                    />
                    {showActionMenu && (
                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: "46px",
                          backgroundColor: "#ffffff",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                          borderRadius: "10px",
                          padding: "6px 0",
                          minWidth: "150px",
                          zIndex: 1050,
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <div
                          className="px-3 py-2 cursor-pointer"
                          style={{ fontSize: "14px", color: "#172B4D", display: "flex", alignItems: "center", gap: "8px" }}
                          onClick={() => {
                            setShowActionMenu(false);
                            navigate(`/asset/edit/${id}`, { state: { id } });
                          }}
                        >
                          <img src={Edit} alt="" style={{ height: "15px" }} /> Edit
                        </div>
                        {(assetView.qr_base64 || assetView.qr_link) && (
                          <div
                            className="px-3 py-2 cursor-pointer"
                            style={{ fontSize: "14px", color: "#172B4D", display: "flex", alignItems: "center", gap: "8px" }}
                            onClick={() => {
                              setShowActionMenu(false);
                              printQRCode(assetView.qr_base64 || assetView.qr_link);
                            }}
                          >
                            <img src={Print} alt="" style={{ height: "15px" }} /> Print QR
                          </div>
                        )}
                        {(assetView.qr_base64 || assetView.qr_link) && (
                          <div
                            className="px-3 py-2 cursor-pointer"
                            style={{ fontSize: "14px", color: "#172B4D", display: "flex", alignItems: "center", gap: "8px" }}
                            onClick={() => {
                              setShowActionMenu(false);
                              downloadQRCode(assetView.qr_base64 || assetView.qr_link, assetView.asset_tag || "asset_qr");
                            }}
                          >
                            <img src={Downloadqr} alt="" style={{ height: "15px" }} /> Download QR
                          </div>
                        )}
                        <div
                          className="px-3 py-2 cursor-pointer text-danger"
                          style={{ fontSize: "14px", display: "flex", alignItems: "center", gap: "8px", borderTop: "1px solid #f0f0f0" }}
                          onClick={() => {
                            setShowActionMenu(false);
                            setIsOpenDelete(true);
                          }}
                        >
                          <img src={Delete} alt="" style={{ height: "15px" }} /> Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={3}>
                <div>
                  <img src={profileView || NoAsset} alt="Asset Profile" style={{ height: "80px", width: "80px" }} />
                </div>
              </Col>

              <Col sm={9}>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ fontWeight: "500", fontSize: "20px", color: "#172b4d" }}>{assetView.name || "-"}</div>

                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>{assetView.asset_type || "-"}</div>

                    <div style={{ height: "4px", width: "4px", backgroundColor: "#d9d9d9" }}></div>

                    <div style={{ borderRadius: "100px", padding: "4px 12px", backgroundColor: "#e9f2ff" }}>
                      <div style={{ fontWeight: "300", fontSize: "13px", color: "#172b4d" }}>
                        EOL : <span style={{ fontWeight: "600", fontSize: "11px", color: "#172b4d" }}>{assetView.eol || "-"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "16px" }}>
              <Col sm={6}>
                <div style={{ borderRadius: "100px", padding: "8px 10px", backgroundColor: "#FFF4D4", display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                  <div>
                    <img src={Cost} alt="" style={{ height: "16px" }} />
                  </div>

                  <div style={{ fontWeight: "400", fontSize: "14px", color: "#E8AC00" }}>Cost</div>
                  <div style={{ fontWeight: "300", fontSize: "14px", color: "#E8AC00" }}>:</div>
                  <div title={`₹ ${assetView.cost}`} style={{ fontWeight: "400", fontSize: "16px", color: "#172b4d", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    ₹ <span style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d" }}>{assetView.cost || "-"}</span>
                  </div>
                </div>
              </Col>

              <Col sm={6}>
                <div style={{ borderRadius: "100px", padding: "8px 10px", backgroundColor: "#E0FFE8", display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                  <div>
                    <img src={Allocated} alt="" style={{ height: "16px" }} />
                  </div>

                  <div style={{ fontWeight: "400", fontSize: "16px", color: "#172b4d" }}>{assetView.asset_status || "-"}</div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790A1" }}>
                  Onboarded on <span style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d" }}>{assetView.created || "-"}</span>
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              {/* QR Header */}
              <Col sm={12}>
                <button
                  type="button"
                  onClick={handleQrToggle}
                  style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", outline: "none" }}
                  aria-label="Toggle QR code"
                >
                  <div style={{ height: "40px", borderRadius: "100px", padding: "10px 28px", backgroundColor: "#f8f8f8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <img src={Qr} alt="QR" style={{ height: "24px" }} />
                      <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }}>QR code</div>
                    </div>
                    <div style={{ transition: "transform 0.3s", transform: showQrDetails ? "rotate(180deg)" : "rotate(0deg)" }}>
                      <img src={Dropdown} alt="Dropdown" style={{ height: "8px" }} />
                    </div>
                  </div>
                </button>
              </Col>

              {/* QR Details */}
              {showQrDetails && (
                <Col sm={12}>
                  <div style={{ marginTop: "12px", padding: "24px", backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0px 4px 12px 0px #0000001F" }}>
                    <div style={{ fontWeight: "700", fontSize: "16px", color: "#172b4d", marginBottom: "16px" }}>QR code</div>

                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginBottom: "32px" }}>
                      {assetView.qr_code ? (
                        <>
                          <img
                            src={assetView.qr_code}
                            alt="QR Code"
                            style={{
                              maxWidth: "300px",
                              height: "auto",
                              border: "1px solid #e5e5e5",
                              borderRadius: "8px",
                              padding: "16px",
                              marginBottom: "8px",
                            }}
                          />
                          <span>{assetView.asset_tag}</span>
                        </>
                      ) : (
                        <img src={NoQr} style={{ height: "160px" }} alt="No QR Code" />
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div style={{ display: "flex", gap: "12px", alignItems: "center", width: "100%" }}>
                        <button
                          type="button"
                          onClick={() => printQRCode(assetView.qr_base64)}
                          style={{ display: "flex", gap: "12px", alignItems: "center", borderRadius: "100px", padding: "14px 16px", backgroundColor: "#e4f0ff", height: "36px", width: "100%", justifyContent: "center", cursor: "pointer", border: "none", outline: "none" }}
                        >
                          <div>
                            <img src={Print} style={{ height: "16px" }} alt="Print" />
                          </div>
                          <div style={{ fontWeight: "600", fontSize: "14px", color: "#172b4d" }}>Print</div>
                        </button>

                        <button
                          type="button"
                          onClick={() => downloadQRCode(assetView.qr_base64, `QR-Code-${assetView.code || "asset"}`)}
                          style={{ display: "flex", gap: "12px", alignItems: "center", borderRadius: "100px", padding: "14px 16px", backgroundColor: "#1967d2", height: "36px", width: "100%", justifyContent: "center", cursor: "pointer", border: "none", outline: "none" }}
                        >
                          <div>
                            <img src={Downloadqr} style={{ height: "16px" }} alt="Download" />
                          </div>
                          <div style={{ fontWeight: "600", fontSize: "14px", color: "#ffffff" }}>Download</div>
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ width: "100%", border: "1px solid #ebebeb" }}></div>
              </Col>
            </Row>

            <div>
              <button
                type="button"
                onClick={handleAssetToggle}
                style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", outline: "none", marginBottom: "24px" }}
                aria-label="Toggle About this asset"
              >
                <Row>
                  <Col sm={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "500", fontSize: "18px", color: "#172b4d" }}>About this asset</div>
                      <div style={{ transition: "transform 0.3s", transform: showAssetDetails ? "rotate(180deg)" : "rotate(0deg)" }}>
                        <img src={Down} alt="Toggle" style={{ height: "36px" }} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </button>

              {showAssetDetails && (
                <Row style={{ marginBottom: "24px" }}>
                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Code</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.code || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.code || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Serial Number</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.serial_number || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.serial_number || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Type</div>
                      </Col>
                      <Col sm={6}>
                        <div title="IOT Meter" style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.asset_type || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Asset Tag</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.serial_number || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.asset_tag || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>UOM</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.uom || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.uom || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Workspace</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.uom || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.usage_type || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Onboarded data</div>
                      </Col>
                      <Col sm={6}>
                        <div title={`${assetView.onboard_data || "-"} Kw/h`} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.onboard_data || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Consumption</div>
                      </Col>
                      <Col sm={6}>
                        <div title={`${assetView.consumption || "-"} Kw/h`} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.consumption || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Avg. consumption/ day</div>
                      </Col>
                      <Col sm={6}>
                        <div title={`${assetView.average_consumption || "-"} Kw/h`} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.average_consumption || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ width: "100%", border: "1px solid #ebebeb" }}></div>
              </Col>
            </Row>

            <div>
              <button
                type="button"
                onClick={handleMaintenanceToggle}
                style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", outline: "none", marginBottom: "24px" }}
                aria-label="Toggle Maintenance Information"
              >
                <Row>
                  <Col sm={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "500", fontSize: "18px", color: "#172b4d" }}>Maintenance Information</div>
                      <div style={{ transition: "transform 0.3s", transform: showMaintenanceDetails ? "rotate(180deg)" : "rotate(0deg)" }}>
                        <img src={Down} alt="Toggle" style={{ height: "36px" }} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </button>

              {showMaintenanceDetails && (
                <Row style={{ marginBottom: "24px" }}>
                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Location</div>
                      </Col>
                      <Col sm={6}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" }}>
                          <img src={Location} alt="" style={{ height: "20px", flexShrink: 0 }} />
                          <div title={assetView.location || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                            {assetView.location || "-"}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Department</div>
                      </Col>
                      <Col sm={6}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" }}>
                          <img src={IT} alt="" style={{ height: "20px", flexShrink: 0 }} />
                          <div title={assetView.department || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                            {assetView.department || "-"}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Used By</div>
                      </Col>
                      <Col sm={6}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" }}>
                          <img src={Used} alt="" style={{ height: "20px", flexShrink: 0 }} />
                          <div title={assetView.assigned_to || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                            {assetView.assigned_to || "-"}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Managed By</div>
                      </Col>
                      <Col sm={6}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" }}>
                          <img src={Managed} alt="" style={{ height: "20px", flexShrink: 0 }} />
                          <div title={assetView.managed_by || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                            {assetView.managed_by || "-"}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Last Reading</div>
                      </Col>
                      <Col sm={6}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" }}>
                          <img src={LastReading} alt="" style={{ height: "20px", flexShrink: 0 }} />
                          <div title={assetView.last_reading || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                            {assetView.last_reading || "-"}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ width: "100%", border: "1px solid #ebebeb" }}></div>
              </Col>
            </Row>

            <div>
              <button
                type="button"
                onClick={handleInvoiceToggle}
                style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", outline: "none", marginBottom: "24px" }}
                aria-label="Toggle Invoice Information"
              >
                <Row>
                  <Col sm={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "500", fontSize: "18px", color: "#172b4d" }}>Invoice Information</div>
                      <div style={{ transition: "transform 0.3s", transform: showInvoiceDetails ? "rotate(180deg)" : "rotate(0deg)" }}>
                        <img src={Down} alt="Toggle" style={{ height: "36px" }} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </button>

              {showInvoiceDetails && (
                <Row style={{ marginBottom: "24px" }}>
                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Invoice Number</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.invoice_number || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.invoice_number || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Invoice Date</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.invoice_date || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.invoice_date || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Depreciation/Year</div>
                      </Col>
                      <Col sm={6}>
                        <div title={`${assetView.depreciation_percentage || "-"}%`} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.depreciation_percentage || "-"}%
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Vendor</div>
                      </Col>
                      <Col sm={6}>
                        <div title={assetView.vendor_name || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.vendor_name || "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12} style={{ marginBottom: "16px" }}>
                    <Row>
                      <Col sm={6}>
                        <div style={{ fontWeight: "300", fontSize: "14px", color: "#8790a1" }}>Warranty Period</div>
                      </Col>
                      <Col sm={6}>
                        <div title={`${assetView.warranty_value || ""} ${assetView.warranty_unit || ""}`.trim() || "-"} style={{ fontWeight: "300", fontSize: "15px", color: "#21272c", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {assetView.warranty_value && assetView.warranty_unit ? `${assetView.warranty_value} ${assetView.warranty_unit}` : "-"}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </Col>

        <Col xs={12} sm={12} md={12} lg={6} xl={8}>
          <div style={{ width: "100%", borderRadius: "24px", padding: "14px 24px", backgroundColor: "#ffffff", textAlign: "left" }}>
            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ fontWeight: "500", fontSize: "18px", color: "#172b4d" }}>Assigned to</div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div>
                    <img src={assetView.assignee_profile || NoProfile} alt="Assignee Profile" style={{ height: "48px" }} />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "600", fontSize: "14px", color: "#172b4d" }}>{assetView.assigned_to || "-"}</div>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Assigned on {assetView.assigned_on || "-"}</div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ border: "1px solid #ebebeb" }}></div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "8px" }}>
              {options.map((label) => (
                <Col key={label} xs={12} sm={12} md={3} lg={6} xl={2} style={{ marginBottom: "16px" }}>
                  <button
                    type="button"
                    title={label}
                    onClick={() => setSelectedTab(label)}
                    style={{
                      height: "36px",
                      width: "100%",
                      borderRadius: "66px",
                      padding: "10px 18px",
                      fontWeight: selectedTab === label ? "700" : "500",
                      fontSize: "14px",
                      lineHeight: "100%",
                      backgroundColor: selectedTab === label ? "#3b84e6" : "#F5F5F5",
                      color: selectedTab === label ? "#ffffff" : "#172b4d",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                      border: "none",
                      outline: "none"
                    }}
                  >
                    {label}
                  </button>
                </Col>
              ))}
            </Row>

            {selectedTab === "Gate Logs" && (
              <>
                <Row style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Records : {gateCount || 0}</div>
                  </Col>

                  <Col sm={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px", border: "1px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
                      <img src={Search} alt="search" style={{ width: "16px" }} />
                      <input type="search" placeholder="Search Gate logs" value={gateSearch} onChange={(e) => setGateSearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col sm={12}>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <div style={{ minWidth: "900px", width: "100%" }}>
                        <div style={{ display: "flex" }}>
                          {["Date", "Time", "Type", "Employee", "Checked By"].map((header, index) => (
                            <div key={index} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#f5f8fa", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              <div title={header} style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {header}
                              </div>
                              <img src={Drag} alt="drag" style={{ height: "10px", marginLeft: "8px" }} />
                            </div>
                          ))}
                        </div>
                        {gateList?.length > 0 ? (
                          gateList.map((log, rowIndex) => (
                            <div key={rowIndex} style={{ display: "flex" }}>
                              {[log.date, log.time, log.type, log.emp, log.checker].map((cell, cellIndex) => (
                                <div key={cellIndex} style={{ flex: 1, border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#ffffff", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  <div title={cell} style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {cell}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", color: "#999" }}>No gate logs available</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "32px" }}>
                  <Col sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ fontWeight: "400", fontSize: "13px", color: "#172b4d" }}>Records per page :</div>
                      <div>
                        <select value={itemsPerGatePage} onChange={(e) => setItemsPerGatePage(e.target.value)} style={{ borderRadius: "6px", height: "32px", border: "1px solid #e5e5e5", padding: "8px 12px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "13px", color: "#172b4d" }}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={PageLeft} alt="Previous Page" style={{ height: "32px" }} />} nextLabel={<img src={PageRight} alt="Next Page" style={{ height: "32px" }} />} breakLabel={"..."} pageCount={gatePageCount + 1} marginPagesDisplayed={2} onPageChange={handleGatePageClick} pageRangeDisplayed={3} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "Assigned History" && (
              <>
                <Row style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Records : {historyCount || 0}</div>
                  </Col>

                  <Col sm={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px", border: "1px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
                      <img src={Search} alt="search" style={{ width: "16px" }} />
                      <input type="search" placeholder="Search Assigned History" value={historySearch} onChange={(e) => setHistorySearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col sm={12}>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <div style={{ minWidth: "900px", width: "100%" }}>
                        <div style={{ display: "flex" }}>
                          {["Date", "Assigned To", "Assigned By"].map((header, index) => (
                            <div key={index} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#f5f8fa", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              <div title={header} style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {header}
                              </div>
                            </div>
                          ))}
                        </div>
                        {historyList.length > 0 ? (
                          historyList.map((row, rowIndex) => (
                            <div key={rowIndex} style={{ display: "flex" }}>
                              {[row.date, row.assignee_to, row.assigned_by].map((cell, cellIndex) => (
                                <div key={cellIndex} style={{ flex: 1, border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#ffffff", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  <div title={cell} style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {cell}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", color: "#999" }}>No assignment history found</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "32px" }}>
                  <Col sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ fontWeight: "400", fontSize: "13px", color: "#172b4d" }}>Records per page :</div>
                      <div>
                        <select value={itemsPerHistoryPage} onChange={(e) => setItemsPerHistoryPage(e.target.value)} style={{ borderRadius: "6px", height: "32px", border: "1px solid #e5e5e5", padding: "8px 12px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "13px", color: "#172b4d" }}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={PageLeft} alt="Previous Page" style={{ height: "32px" }} />} nextLabel={<img src={PageRight} alt="Next Page" style={{ height: "32px" }} />} breakLabel={"..."} pageCount={historyPageCount + 1} marginPagesDisplayed={2} onPageChange={handleHistoryPageClick} pageRangeDisplayed={3} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "Data Entries" && (
              <>
                <Row style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Records : {dataCount || 0}</div>
                  </Col>

                  <Col sm={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px", border: "1px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
                      <img src={Search} alt="search" style={{ width: "16px" }} />
                      <input type="search" placeholder="Search Data Entries" value={dataSearch} onChange={(e) => setDataSearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col sm={12}>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <div style={{ minWidth: "900px", width: "100%" }}>
                        <div style={{ display: "flex" }}>
                          {["Date", "Current", "Previous", "Difference", "Checked By"].map((header, index) => (
                            <div key={index} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#f5f8fa", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              <div title={header} style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {header}
                              </div>
                            </div>
                          ))}
                        </div>
                        {dataList.length > 0 ? (
                          dataList.map((row, rowIndex) => (
                            <div key={rowIndex} style={{ display: "flex" }}>
                              {[row.date, row.current, row.previous, row.difference, row.emp].map((cell, cellIndex) => (
                                <div key={cellIndex} style={{ flex: 1, border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#ffffff", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  <div title={cell} style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {cell}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", color: "#999" }}>No data entries available</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "32px" }}>
                  <Col sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ fontWeight: "400", fontSize: "13px", color: "#172b4d" }}>Records per page :</div>
                      <div>
                        <select value={itemsPerDataPage} onChange={(e) => setItemsPerDataPage(e.target.value)} style={{ borderRadius: "6px", height: "32px", border: "1px solid #e5e5e5", padding: "8px 12px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "13px", color: "#172b4d" }}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={PageLeft} alt="Previous Page" style={{ height: "32px" }} />} nextLabel={<img src={PageRight} alt="Next Page" style={{ height: "32px" }} />} breakLabel={"..."} pageCount={dataPageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handleDataPageClick} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "Validation" && (
              <>
                <Row style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Records : {validationsCount}</div>
                  </Col>

                  <Col sm={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px", border: "1px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
                      <img src={Search} alt="search" style={{ width: "16px" }} />
                      <input type="search" placeholder="Search Validations" value={validationsSearch} onChange={(e) => setValidationsSearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col sm={12}>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <div style={{ minWidth: "900px", width: "100%" }}>
                        <div style={{ display: "flex" }}>
                          {["Date", "Reference", "Used By", "Location", "Checked By", "Status"].map((header, index) => (
                            <div key={index} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#f5f8fa", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              <div title={header} style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {header}
                              </div>
                              <img src={Drag} alt="drag" style={{ height: "10px", marginLeft: "8px" }} />
                            </div>
                          ))}
                        </div>
                        {validationsList?.length > 0 ? (
                          validationsList.map((row, rowIndex) => (
                            <button
                              key={rowIndex}
                              type="button"
                              style={{ display: "flex", width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", outline: "none" }}
                              onClick={() => {
                                setReferenceId(row.id);
                              }}
                              aria-label={`View validation details for ${row.reference}`}
                            >
                              {[row.date, row.reference, row.emp, row.location, row.checker, (row.check_status === true || row.check_status == 1) ? "Success" : "Error"].map((cell, cellIndex) => (
                                <div key={cellIndex} style={{ flex: 1, border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#ffffff", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  <div title={cell} style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {cell}
                                  </div>
                                </div>
                              ))}
                            </button>
                          ))
                        ) : (
                          <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", color: "#999" }}>No validations found</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "32px" }}>
                  <Col sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ fontWeight: "400", fontSize: "13px", color: "#172b4d" }}>Records per page :</div>
                      <div>
                        <select value={itemsPerValidationsPage} onChange={(e) => setItemsPerValidationsPage(e.target.value)} style={{ borderRadius: "6px", height: "32px", border: "1px solid #e5e5e5", padding: "8px 12px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "13px", color: "#172b4d" }}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={PageLeft} alt="Previous Page" style={{ height: "32px" }} />} nextLabel={<img src={PageRight} alt="Next Page" style={{ height: "32px" }} />} breakLabel={"..."} pageCount={validationsPageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handleValidationsPageClick} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "Edited History" && (
              <>
                <Row style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6}>
                    <div style={{ fontWeight: "300", fontSize: "14px", color: "#172b4d" }}>Records : {editedHistoryCount || 0}</div>
                  </Col>

                  <Col sm={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px", border: "1px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
                      <img src={Search} alt="search" style={{ width: "16px" }} />
                      <input type="search" placeholder="Search Edited History" value={editedHistorySearch} onChange={(e) => setEditedHistorySearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col sm={12}>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <div style={{ minWidth: "900px", width: "100%" }}>
                        <div style={{ display: "flex" }}>
                          {["Updated By", "Updated At", "Updated Fields"].map((header, index) => (
                            <div key={index} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#f5f8fa", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              <div title={header} style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {header}
                              </div>
                              <img src={Drag} alt="drag" style={{ height: "10px", marginLeft: "8px" }} />
                            </div>
                          ))}
                        </div>

                        {editedHistoryList.length > 0 ? (
                          editedHistoryList.map((row, rowIndex) => (
                            <div key={rowIndex} style={{ display: "flex" }}>
                              {[row.updated_by, row.date, row.updated_fields].map((cell, cellIndex) => (
                                <div key={cellIndex} style={{ flex: 1, border: "1px solid #e5e5e5", padding: "10px 16px", backgroundColor: "#ffffff", height: "40px", boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  <div title={cell} style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {cell}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", color: "#999" }}>No edit history available</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "32px" }}>
                  <Col sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ fontWeight: "400", fontSize: "13px", color: "#172b4d" }}>Records per page :</div>
                      <div>
                        <select value={itemsPerEditedHistoryPage} onChange={(e) => setItemsPerEditedHistoryPage(Number(e.target.value))} style={{ borderRadius: "6px", height: "32px", border: "1px solid #e5e5e5", padding: "8px 12px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "13px", color: "#172b4d" }}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6}>
                    <div className="d-flex justify-content-end">
                      <ReactPaginate previousLabel={<img src={PageLeft} alt="Previous Page" style={{ height: "32px" }} />} nextLabel={<img src={PageRight} alt="Next Page" style={{ height: "32px" }} />} breakLabel={"..."} pageCount={editedHistoryPageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handleEditedHistoryPageClick} containerClassName={"pagination"} activeClassName={"active"} />
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "Reminders" && (
              <>
                <Row style={{ marginTop: "32px", marginBottom: "32px", display: "flex", alignItems: "center" }}>
                  <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontWeight: "600", fontSize: "18px", color: "#172b4d" }}>Reminders</div>
                  </Col>
                  <Col sm={6} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <button
                      onClick={() => {
                        setShowReminder(true);
                      }}
                      style={{ display: "flex", gap: "12px", alignItems: "center", height: "40px", borderRadius: "12px", border: "1px solid #ebebeb", padding: "0 16px", backgroundColor: "#ffffff", width: "fit-content", cursor: "pointer", outline: "none" }}
                    >
                      <img src={Reminder} alt="Add" style={{ height: "20px" }} />
                      <span style={{ fontWeight: "600", fontSize: "14px", color: "#3b84e6" }}>Add Reminder</span>
                    </button>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    {reminders?.length > 0 ? (
                      reminders.map((item) => (
                        <div key={item.id} style={{ borderRadius: "16px", border: "1px solid #ebebeb", backgroundColor: "#ffffff", padding: "12px", marginBottom: "24px" }}>
                          <Row style={{ marginBottom: "16px" }}>
                            <Col sm={12} md={8}>
                              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <img src={Notification} alt="Notification" style={{ height: "44px" }} />
                                <div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <div style={{ fontWeight: "600", fontSize: "16px", color: "#172b4d" }}>{item.trigger_seq}</div>
                                    <div style={{ width: "4px", height: "4px", backgroundColor: "#d9d9d9" }} />
                                    <div style={{ fontSize: "12px", padding: "6px 12px", borderRadius: "100px", backgroundColor: "#e9f1ff", color: "#172b4d" }}>{item.type}</div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "4px" }}>
                                    <img src={Warranty} alt="Warranty" style={{ height: "14px" }} />
                                    <div style={{ fontSize: "13px", color: "#249244" }}>Warranty renewal information</div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col sm={12} md={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" }}>
                              <button
                                type="button"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                onClick={() => setEditReminder(item)}
                                aria-label="Edit Reminder"
                              >
                                <img src={Edit} alt="Edit" style={{ height: "32px" }} />
                              </button>
                              <button
                                type="button"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                onClick={() => {
                                  if (item.id != null && item.id != "") {
                                    deleteReminderApi(item.id);
                                  }
                                }}
                                aria-label="Delete Reminder"
                              >
                                <img src={Delete} alt="Delete" style={{ height: "32px" }} />
                              </button>
                            </Col>
                          </Row>

                          <div style={{ backgroundColor: "#fafafa", borderRadius: "16px", padding: "16px" }}>
                            <Row>
                              <Col xl={4} className="mb-3">
                                <div style={{ borderRight: "1px solid #e5e5e5" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                    <img src={Email} alt="Email" style={{ height: "16px" }} />
                                    <div style={{ fontSize: "11px", fontWeight: "500", color: "#3b84e6" }}>EMAIL</div>
                                  </div>
                                  {item.emails.map((email, i) => (
                                    <div key={i} style={{ fontSize: "13px", color: "#172b4d", paddingLeft: "20px", marginBottom: "4px" }}>
                                      {email}
                                    </div>
                                  ))}
                                </div>
                              </Col>

                              <Col xl={4} className="mb-3">
                                <div style={{ borderRight: "1px solid #e5e5e5" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                    <img src={Mobile} alt="Mobile" style={{ height: "16px" }} />
                                    <div style={{ fontSize: "11px", fontWeight: "500", color: "#3b84e6" }}>MOBILE NUMBER</div>
                                  </div>
                                  {item.mobile_numbers.map((num, i) => (
                                    <div key={i} style={{ fontSize: "13px", color: "#172b4d", paddingLeft: "20px", marginBottom: "4px" }}>
                                      {num}
                                    </div>
                                  ))}
                                </div>
                              </Col>

                              <Col xl={4} className="mb-3">
                                <div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                    <img src={User} alt="User" style={{ height: "16px" }} />
                                    <div style={{ fontSize: "11px", fontWeight: "500", color: "#3b84e6" }}>USER</div>
                                  </div>
                                  {item.user_labels?.map((user, i) => (
                                    <div key={`user${i}`} style={{ fontSize: "13px", color: "#172b4d", paddingLeft: "20px", marginBottom: "4px" }}>
                                      {user.label}
                                    </div>
                                  ))}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <img src={NoData} alt="No Data" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                        <div style={{ fontSize: "14px", color: "#999" }}>No reminders available</div>
                      </div>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {selectedTab === "File" && (
              <>
                <input id="fileInput" type="file" multiple accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv" style={{ display: "none" }} onChange={handleFileUpload} />

                <Row style={{ marginTop: "32px", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontWeight: "600", fontSize: "18px", color: "#172b4d" }}>Files</div>
                  </Col>
                  <Col sm={6} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <button onClick={() => document.getElementById("fileInput").click()} style={{ display: "flex", gap: "12px", alignItems: "center", height: "40px", borderRadius: "12px", border: "1px solid #ebebeb", padding: "0 16px", backgroundColor: "#ffffff", width: "fit-content", cursor: "pointer", outline: "none" }}>
                      <img src={Plus} alt="Add" style={{ height: "20px" }} />
                      <span style={{ fontWeight: "600", fontSize: "14px", color: "#3b84e6" }}>Add New</span>
                    </button>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {fileView?.length > 0 ? (
                        fileView.map((file, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "12px", border: "1px solid #ebebeb", padding: "8px 12px", backgroundColor: "#f8f8f8", marginBottom: "12px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <div>
                                <img src={Excel} alt="file" style={{ height: "32px" }} />
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                <div style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d" }}>{file.file_name}</div>
                                <div style={{ fontWeight: "300", fontSize: "13px", color: "#172b4d" }}>{file.file_size} MB</div>
                              </div>
                            </div>
                            <div>
                              <a href={file.file_path} download target="_blank" rel="noopener noreferrer">
                                <img src={Download} alt="download" style={{ height: "40px", cursor: "pointer" }} />
                              </a>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                          <img src={NoData} alt="No Files" style={{ width: "200px", opacity: 0.7, marginBottom: "12px" }} />
                          <div style={{ fontSize: "14px", color: "#999" }}>No files available</div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </Col>
      </Row>

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default AssetView;
